import { render } from "./RequisitesGroupsPopup.vue?vue&type=template&id=2f958fc1&ts=true"
import script from "./RequisitesGroupsPopup.vue?vue&type=script&lang=ts"
export * from "./RequisitesGroupsPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__